import { getManagement } from '@/shared/restActions';

function getTotalDocumentsBySection(companyId) {
  return getManagement(`/api/v2/statistics/documents/${companyId}`);
}

export default {
  getTotalDocumentsBySection,
};
